import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Download } from 'lucide-react';
import { Action } from '../../../components/aa';
import { errorText, saveCsv } from './sessionShared';

export const ExportAction: React.FC<{
  label: string;
  fileName: string;
  load: () => Promise<{ data: Blob }>;
}> = ({ label, fileName, load }) => {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await load();
      saveCsv(data, fileName);
    } catch (err) {
      toast.error(errorText(err, 'Could not export the responses.'));
    } finally {
      setBusy(false);
    }
  };

  let text = label;
  if (busy) text = 'Exporting…';
  return (
    <Action size="sm" variant="ghost" icon={<Download size={14} />} onClick={run} disabled={busy} reason="Exporting">
      {text}
    </Action>
  );
};

export default ExportAction;
